module.exports = __webpack_public_path__ + "img/team-fill.0a5c622a.svg";